import { useMemo } from 'react';

export const useRenderData = (brand) => {
  const categories = ['Preferred Brands', 'Top Brands', 'More Brands'];

  const renderData = useMemo(
    () => ({
      'Preferred Brands': brand?.preferred_brands || [],
      'Top Brands': brand?.top_brands || [],
      'More Brands': brand?.all_other_brands || [],
    }),
    [brand],
  );

  const availableCategories = categories.filter(
    (category) => renderData[category]?.length > 0,
  );

  return { categories, renderData, availableCategories };
};

export const normalizeString = (str) => {
  return str.toLowerCase().replace(/[^a-z0-9]/gi, '');
};

export const matchBrand = (merchantName, searchedValue) => {
  const normalizedName = normalizeString(merchantName);
  const normalizedSearchedValue = normalizeString(searchedValue);

  if (normalizedName === normalizedSearchedValue) {
    return { matchRank: 100 };
  }
  if (normalizedName.startsWith(normalizedSearchedValue)) {
    return { matchRank: 75 + normalizedSearchedValue.length };
  }
  if (normalizedName.includes(normalizedSearchedValue)) {
    return { matchRank: 50 + normalizedSearchedValue.length };
  }
  if (
    normalizedSearchedValue.length >= 3 &&
    normalizedName.includes(normalizedSearchedValue.slice(0, 3))
  ) {
    return { matchRank: 25 };
  }

  return null;
};
